import moment, { Moment } from 'moment';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { createInitialAttendanceState, formatSelectedMonthYear } from '.';
import Icons from '../../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../../common/widgets/PopoverDialog';
import { config } from '../../../../config';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { Timesheet } from '../../../../models/TimeAndAttendance';
import { resources } from '../../../../resources/resources';

interface ITimeAndAttendanceActionButtonsProps {
  currentDate: Moment;
  isTimesheetLocked: boolean;
  setCurrentDate: React.Dispatch<React.SetStateAction<Moment>>;
  setShowAttendanceDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSubmitTimesheetDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedAttendance: React.Dispatch<
    React.SetStateAction<Timesheet | undefined>
  >;
}

export const TimeAndAttendanceActionButtons = (
  props: ITimeAndAttendanceActionButtonsProps,
) => {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);

  return (
    <div className="taa-actions-wrapper">
      <div className="date-action-wrapper">
        <span
          className="btn btn-icon"
          onClick={() => {
            props.setCurrentDate(
              moment(props.currentDate).subtract({
                month: 1,
              }),
            );
          }}
        >
          <Icons.ArrowLeftMobile />
        </span>
        {!props.isTimesheetLocked ? (
          <span className="date-month">
            <span>
              {formatSelectedMonthYear(
                props.currentDate,
                customerInfo?.languageCode ?? config.defaultLanguage ?? 'ro',
              )}
            </span>
          </span>
        ) : (
          <span className="date-month locked">
            <PopoverDialog
              className="info-tooltip"
              placement="bottom"
              type="hover"
              content={
                <div>
                  {translate(
                    resources.timeAndAttendance.submitTimesheet.lockedMessage,
                  )}
                </div>
              }
            >
              <span>
                {formatSelectedMonthYear(
                  props.currentDate,
                  customerInfo?.languageCode ?? config.defaultLanguage ?? 'ro',
                )}
              </span>
            </PopoverDialog>
          </span>
        )}

        <span
          className="btn btn-icon"
          onClick={() =>
            props.setCurrentDate(
              moment(props.currentDate).add({
                month: 1,
              }),
            )
          }
        >
          <Icons.ArrowRightMobile />
        </span>
      </div>
      <div className="timesheet-actions-wrapper">
        <button
          disabled={props.isTimesheetLocked}
          className="btn btn-solid btn-sm"
          onClick={() => {
            navigate('/my-account/time-and-attendance');
            props.setShowAttendanceDialog(true);
            props.setSelectedAttendance(
              createInitialAttendanceState(new Date()),
            );
          }}
        >
          <span className="btn-icon">
            <Icons.CalendarEdit />
          </span>
          <span className="btn-text">
            {translate(resources.timeAndAttendance.completeTimesheet)}
          </span>
        </button>

        <button
          className="btn btn-solid btn-sm"
          disabled={props.isTimesheetLocked}
          onClick={() => {
            props.setShowSubmitTimesheetDialog(true);
          }}
        >
          <span className="btn-icon">
            <Icons.Check />
          </span>
          <span className="btn-text">
            {translate(resources.timeAndAttendance.finish)}
          </span>
        </button>
      </div>
    </div>
  );
};
